/**
 * 与「强制真实姓名」弹窗一致：须为中文汉字（含生僻字）至少两个汉字，可含间隔号 ·
 * @param {string} raw
 * @returns {string|null} 错误文案；null 表示通过（含空字符串——由表单 required 另行处理）
 */
export function getChineseDisplayNameValidationError(raw) {
  const v = (raw || '').trim()
  if (!v) {
    return null
  }
  if (v.length > 128) {
    return '过长'
  }
  let hanCount = 0
  for (const ch of v) {
    if (ch === '·' || ch === '\u00b7') {
      continue
    }
    if (ch === '\u3007' || /\p{Script=Han}/u.test(ch)) {
      hanCount++
      continue
    }
    return '须为中文姓名（规范汉字），不能包含字母、数字或其它外文符号'
  }
  if (hanCount < 2) {
    return '姓名至少包含两个汉字'
  }
  return null
}

/**
 * @param {string} raw
 * @returns {boolean} 非空且符合中文姓名规则时为 true
 */
export function isValidChineseRealName(raw) {
  const v = (raw || '').trim()
  if (!v) {
    return false
  }
  return getChineseDisplayNameValidationError(raw) === null
}
